import {
  FFavMealDetailsConnectorApollo,
  TrackerAddMealConnectorApollo,
  SaveAsUserMealConnectorApollo,
  useAppContext,
} from '@front-activerse/common-components';
import { useParams } from 'react-router-dom';
import TrackerAddMealContainer from './TrackerAddFavMealContainer';

const TrackerIndexPage = () => {
  const { dietMealId } = useParams();
  const { post } = useAppContext();

  if (!dietMealId) {
    return <div>Missing parameters</div>;
  }

  return (
    <FFavMealDetailsConnectorApollo mealId={+dietMealId}>
      {({ ...favMealData }) => (
        <TrackerAddMealConnectorApollo post={post}>
          {({ addMeal }: { addMeal: (input: any, saveYourMeal: boolean) => Promise<any> }) => (
            <SaveAsUserMealConnectorApollo post={post}>
              {({ saveAsUserMeal }: { saveAsUserMeal: (input: any) => Promise<any> }) => (
                <TrackerAddMealContainer
                  {...favMealData.favMeal}
                  loading={favMealData.loading}
                  addMeal={addMeal}
                  saveAsUserMeal={saveAsUserMeal}
                  dietMealId={dietMealId}
                  key={dietMealId}
                />
              )}
            </SaveAsUserMealConnectorApollo>
          )}
        </TrackerAddMealConnectorApollo>
      )}
    </FFavMealDetailsConnectorApollo>
  );
};

export default TrackerIndexPage;
